<script>
  /** @type {string} */
  export let cardUrl;

  /** @type {string} */
  export let title;
</script>

<a href={cardUrl}>
  <div class="card h-100">
    <div class="card-img-wrapper">
      <slot name="card-image"></slot>
    </div>
    <div class="card-body-wrapper">
      <div class="card-body">
        <h2 class="card-title mb-8" {title}>{@html title}</h2>
        <p class="card-text"><slot name="card-text"></slot></p>
      </div>
    </div>
  </div>
</a>

<style>
  a {
    text-decoration: none;
  }

  .card {
    box-shadow: 0px 0px 10px 5px var(--grey-06);
    border-radius: 12px;
    border: 0;
    transition:
      box-shadow 0.3s ease,
      transform 0.3s ease;
  }

  .card:hover {
    box-shadow: 0px 0px 15px 10px var(--grey-06);
    transform: scale(1.05);
  }
  .card-body-wrapper {
    height: 100%;
    border: 2px solid var(--grey-15);
    border-top: 0;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  .card-img-wrapper {
    border: 2px solid var(--grey-15);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  .card-body {
    margin: 10px;
  }

  .card-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  h2 {
    font-size: 1.3rem;
  }
</style>
